import { BFFAgent } from 'BFFAgent'
import { put, call } from 'redux-saga/effects'
import {
  STOCK_TAKING_CAR_MANAGEMENT_DETAILS_FAILURE,
  STOCK_TAKING_CAR_MANAGEMENT_DETAILS_SUCCESS
} from '../constants'

export function* getTakingCarDetailsSaga({ data: { takingCarId } }) {
  try {
    const responseGetTakingCarDetails = yield call(
      BFFAgent.Stock.TakingCarManagement.getTakingCarDetails,
      takingCarId
    )

    if (responseGetTakingCarDetails) {
      yield put({
        type: STOCK_TAKING_CAR_MANAGEMENT_DETAILS_SUCCESS,
        data: responseGetTakingCarDetails?.data?.request
      })
    }
  } catch (error) {
    yield put({
      type: STOCK_TAKING_CAR_MANAGEMENT_DETAILS_FAILURE,
      data: { error }
    })
  }
}
